import { render, staticRenderFns } from "./ItemChatInput.vue?vue&type=template&id=68bf646c&scoped=true&lang=pug&"
import script from "./ItemChatInput.vue?vue&type=script&lang=js&"
export * from "./ItemChatInput.vue?vue&type=script&lang=js&"
import style0 from "./ItemChatInput.vue?vue&type=style&index=0&id=68bf646c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf646c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
